import styled from 'styled-components'

const SideBarSize = 78

export const Container = styled.main`
  width: 100vw;
  min-height: calc(100vh - 200px);
  margin-top: 50px;
  padding: 0 1.5rem;

  @media only screen and (min-width: 800px) {
    margin: 60px 32px 0 ${SideBarSize + 32}px;
    padding: 0;

    width: unset;
  }
`

export const Content = styled.div`
  max-width: 1300px;
  margin: 0 auto;
`

export const LoadingContent = styled.div`
  .carousel {
    height: 165px;
  }

  .modules {
    margin-top: 40px;

    height: 370px;
  }

  @media only screen and (min-width: 800px) {
    .carousel {
      height: 170px;
    }

    .modules {
      height: 510px;
    }
  }
`

export const EmptyContent = styled.div`
  border-radius: 4px;

  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => `rgba(${theme.grayscale.neutral}, 0.5)`};

  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  gap: 24px 48px;

  padding: 40px 16px;

  h2,
  p {
    margin: 0;
  }

  .image-svg {
    width: 60%;
    max-width: 250px;
  }

  .text {
    max-width: 270px;

    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

    .title {
      font-size: 0.875rem;
      font-weight: 700;

      margin-bottom: 16px;
    }

    .description {
      font-size: 0.75rem;
      font-weight: 400;
    }
  }

  @media only screen and (min-width: 800px) {
    justify-content: space-evenly;

    padding: 60px 16px;

    .image-svg {
      width: 30%;

      max-width: 440px;
    }

    .text {
      width: 45%;
      max-width: 586px;

      .title {
        font-size: 1.875rem;
      }

      .description {
        font-size: 1.125rem;
      }
    }
  }
`

export const NoDataContent = styled.div`
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => `rgba(${theme.grayscale.neutral}, 0.5)`};

  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  gap: 24px 10px;

  padding: 56px 24px 24px;

  h2,
  p {
    margin: 0;
  }

  .image-svg {
    width: 90%;
    max-width: 300px;
  }

  .text {
    max-width: 270px;

    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

    .title {
      font-size: 0.875rem;
      font-weight: 700;

      margin-bottom: 16px;
    }

    .description {
      font-size: 0.75rem;
      font-weight: 400;
    }
  }

  @media only screen and (min-width: 800px) {
    justify-content: space-evenly;

    padding: 60px 16px;

    .image-svg {
      width: 40%;

      max-width: 560px;
      min-width: 390px;
    }

    .text {
      width: 45%;
      max-width: 586px;

      .title {
        font-size: 1.875rem;
      }

      .description {
        font-size: 1.125rem;
      }
    }
  }
`

export const ErrorContent = styled.div`
  border-radius: 4px;

  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => `rgba(${theme.grayscale.neutral}, 0.5)`};

  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  gap: 24px 48px;

  padding: 40px 16px;

  h2,
  p {
    margin: 0;
  }

  .image-svg {
    width: 80%;
    max-width: 250px;
  }

  .text {
    max-width: 270px;

    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

    .title {
      font-size: 0.875rem;
      font-weight: 700;

      margin-bottom: 16px;
    }

    .description {
      font-size: 0.75rem;
      font-weight: 400;
    }
  }

  @media only screen and (min-width: 800px) {
    justify-content: space-evenly;

    padding: 60px 16px;

    .image-svg {
      width: 30%;

      max-width: 440px;
    }

    .text {
      width: 45%;
      max-width: 586px;

      .title {
        font-size: 1.875rem;
      }

      .description {
        font-size: 1.125rem;
      }
    }
  }
`

export const UpperContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  gap: 42px;

  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

  .title {
    margin: 0;

    font-size: 1.5rem;
    font-weight: 700;

    margin-bottom: 16px;
  }

  .description {
    margin: 0;

    font-size: 1rem;
    font-weight: 400;
  }

  .dropdown-wrapper {
    width: 100%;

    .title {
      margin: 0;

      font-size: 0.875rem;
      font-weight: 700;

      margin-bottom: 8px;
    }
  }

  margin-bottom: 42px;

  @media only screen and (min-width: 800px) {
    flex-direction: row;

    .title {
      font-size: 2.25rem;
    }

    .dropdown-wrapper {
      width: unset;
    }
  }
`

export const CarouselWrapper = styled.div`
  .tooltip-wrapper {
    display: flex;
    align-items: center;

    gap: 18px;
    margin-bottom: 22px;
  }

  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

  .title {
    margin: 0;

    font-size: 1.12rem;
    font-weight: 700;
  }

  @media only screen and (min-width: 800px) {
    .tooltip-wrapper {
      margin-bottom: 16px;
    }

    .title {
      font-size: 1.5rem;
    }
  }
`

export const ModulosWrapper = styled.div`
  margin-top: 40px;

  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

  .tooltip-wrapper {
    display: flex;
    align-items: center;

    gap: 18px;
    margin-bottom: 22px;
  }

  .title {
    margin: 0;

    font-size: 1.125rem;
    font-weight: 700;
  }

  @media only screen and (min-width: 800px) {
    .title {
      font-size: 1.625rem;
    }
  }
`

export const StudyTimeWrapper = styled.div`
  margin-top: 40px;

  .tooltip-wrapper {
    display: flex;
    align-items: center;

    gap: 18px;
    margin-bottom: 22px;
  }

  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

  .title {
    margin: 0;

    font-size: 1.12rem;
    font-weight: 700;
  }

  @media only screen and (min-width: 800px) {
    .tooltip-wrapper {
      margin-bottom: 16px;
    }

    .title {
      font-size: 1.5rem;
    }
  }
`
